/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DeviceService } from '../../../modules/shared/services/device.service';
import { DomSanitizer } from '@angular/platform-browser';
import { saveAs } from 'file-saver';
import { PdfPrintResult } from '../../../modules/map/command/print/state/print-options.model';

export interface PdfData {
    pdfBlob: Blob | string;
    isBlob: boolean;
}

@Component({
    selector: 'dash-gis-print-pdf-dialog',
    templateUrl: './printPdfDialog.html',
    styleUrls: [ './printPdfDialog.scss' ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PdfDialogComponent implements AfterViewInit {

    constructor(
        private dialogRef: MatDialogRef<PdfDialogComponent>,
        private deviceService: DeviceService,
        private sanitizer: DomSanitizer,
        @Inject(MAT_DIALOG_DATA) private pdfData: PdfPrintResult
    ) {}

    @ViewChild('objectElement', { read: ElementRef })
    private objectElement: ElementRef;

    ngAfterViewInit(): void {
        if (this.isIOS || (
            !this.isFirefox
            && this.objectElement
            && !(this.objectElement.nativeElement as HTMLObjectElement).contentDocument
        )) {
            this.dialogRef.updateSize();
        }
    }

    doDownload() {
        saveAs(this.pdfData.blob, this.pdfData.filename);
    }

    close() {
        this.dialogRef.close();
    }

    private blobToBlobUri(blob: Blob): string {
        return URL.createObjectURL(blob);
    }

    get isIOS() {
        return this.deviceService.isIOS;
    }

    get isFirefox() {
        return this.deviceService.isFirefox;
    }

    get blobUri() {
        const uri = this.pdfData.isBlob
            ? this.blobToBlobUri(this.pdfData.blob as Blob)
            : this.pdfData.blob;
        return this.sanitizer.bypassSecurityTrustResourceUrl(uri as string);
    }
}
